import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var UserCircleOutline = function UserCircleOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM11.9893 15.9609C8.95996 15.9609 6.60742 17.0459 5.46875 18.292C4.00781 16.7129 3.11621 14.5859 3.11621 12.2441C3.11621 7.31348 7.05859 3.36035 11.9785 3.36035C16.9092 3.36035 20.873 7.31348 20.8838 12.2441C20.8838 14.5859 19.9922 16.7129 18.5205 18.3027C17.3818 17.0459 15.0293 15.9609 11.9893 15.9609ZM11.9893 14.1992C14.0732 14.2207 15.6953 12.4375 15.6953 10.1387C15.6953 7.96875 14.0625 6.15332 11.9893 6.15332C9.92676 6.15332 8.2832 7.96875 8.29395 10.1387C8.30469 12.4375 9.91602 14.1885 11.9893 14.1992Z"
  })));
};

UserCircleOutline.displayName = 'UserCircleOutline';
export default UserCircleOutline;